import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MapaRotaOnibusComponent } from '../../components/mapa-rota-onibus/mapa-rota-onibus.component';
import { CarouselDestaquesComponent } from '../../components/carousel-destaques/carousel-destaques.component';
import { TrafegoComponent } from '../../components/trafego/trafego.component';
import { ClimaWidgetComponent } from '../../components/clima-widget/clima-widget.component';

@Component({
  selector: 'app-info-filtro',
  standalone: true,
  imports: [RouterModule, CommonModule, MapaRotaOnibusComponent, CarouselDestaquesComponent, TrafegoComponent, ClimaWidgetComponent],
  templateUrl: './info-filtro.component.html',
  styleUrls: ['./info-filtro.component.scss']
})
export class InfoFiltroComponent implements OnInit {
  @ViewChild(MapaRotaOnibusComponent) mapaRotaOnibusComponent!: MapaRotaOnibusComponent;

  pageTitle: string | null = null;
  bannerImage: string | null = null;
  selectedItem: any = null;
  paginatedItems: any[] = [];
  filtro: string = 'teste';
  info: string = 'teste';
  address: string = '';
  area: string = '';
  hours: {
    weekday: string;
    saturday: string;
    sunday: string;
  } = { weekday: '', saturday: '', sunday: '' };
  liveStatus: string = '';
  mockDataCard: any = {};
  activeItem: any = null;
  locations: { latitude: number, longitude: number }[] = [];

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // location.reload();
    this.route.paramMap.subscribe((params) => {
      this.pageTitle = params.get('name');
      this.bannerImage = this.route.snapshot.paramMap.get('image');
      

      // if (this.mapaRotaOnibusComponent) {
      const mapaRotaOnibusComponent = new MapaRotaOnibusComponent();
      mapaRotaOnibusComponent.resetMap();
      // }
    });

    this.paginatedItems = [
      { name: 'Acessibilidade', icon: 'fa-solid fa-universal-access', count: 2 },
      { name: 'Ducha', icon: 'fa-solid fa-shower', count: 5 },
      { name: 'Bebedouro', icon: 'fa-solid fa-bottle-water', count: 3 },
      { name: 'Salva-vidas', icon: 'fa-solid fa-life-ring', count: 4 },
      { name: 'Banheiros', icon: 'fa-solid fa-toilet', count: 6 },
      { name: 'Segurança', icon: 'fa-solid fa-person-military-pointing', count: 7 },
      { name: 'Quadras', icon: 'fa-solid fa-basketball', count: 8 },
      { name: 'Alimentação', icon: 'fa-solid fa-hamburger', count: 8 },
    ];

    this.mockDataCard = {
      address: "Rua das Acácias, 100 - Jardins das águas",
      area: "100 km",
      hours: {
        weekday: "08:00h às 21:00h",
        saturday: "08:00h às 14:00h",
        sunday: "08:00h às 12:00h",
      },
      liveStatus: "Não movimentado",
    };

    this.address = this.mockDataCard.address;
    this.area = this.mockDataCard.area;
    this.hours = this.mockDataCard.hours;
    this.liveStatus = this.mockDataCard.liveStatus;

    const defaultItem = this.paginatedItems.find(item => item.name === 'Acessibilidade');
    if (defaultItem) {
      this.selectItem(defaultItem);
    }

    console.log(this.mockDataCard);
  }

  selectItem(item: any): void {
    this.selectedItem = item;
    this.activeItem = item;

    if (item.name === 'Ducha') {
      this.filtro = 'Ducha';
      this.info = 'Informações sobre a ducha selecionada.';
    } else if (item.name === 'Acessibilidade') {
      this.filtro = 'Acessibilidade';
      this.info = 'Informações sobre a Acessibilidade.';
    } else if (item.name === 'Bebedouro') {
      this.filtro = 'Bebedouro';
      this.info = 'Informações sobre o Bebedouro.';
    } else {
      this.filtro = 'Outro';
      this.info = 'Informações sobre outro item selecionado.';
    }
  }

  isActive(item: any): boolean {
    return this.activeItem === item;
  }
}
